import { GameTemplateServiceData } from 'services/GameHosting/DeploymentTemp/deploymentTemplateServiceType';
import { SortParams } from 'types/common/sorting';
import { FetchAction, ResetReducerAction } from 'types/services/redux-action';
import { FetchReducer, SortState } from 'types/services/redux-state';

export const FETCH_GAME_DEPLOYMENT_TEMPLATE = 'FETCH_GAME_DEPLOYMENT_TEMPLATE';

export const FETCH_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING = 'FETCH_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const FETCH_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR = 'FETCH_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const FETCH_GAME_DEPLOYMENT_TEMPLATE_ID = 'FETCH_GAME_DEPLOYMENT_TEMPLATE_ID';

export const FETCH_GAME_DEPLOYMENT_TEMPLATE_ID_IS_PENDING = 'FETCH_GAME_DEPLOYMENT_TEMPLATE_ID_IS_PENDING';

export const FETCH_GAME_DEPLOYMENT_TEMPLATE_ID_IS_ERROR = 'FETCH_GAME_DEPLOYMENT_TEMPLATE_ID_IS_ERROR';

export const CREATE_GAME_DEPLOYMENT_TEMPLATE = 'CREATE_GAME_DEPLOYMENT_TEMPLATE';

export const CREATE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING = 'CREATE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const CREATE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR = 'CREATE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const UPDATE_GAME_DEPLOYMENT_TEMPLATE = 'UPDATE_GAME_DEPLOYMENT_TEMPLATE';

export const UPDATE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING = 'UPDATE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const UPDATE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR = 'UPDATE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const DELETE_GAME_DEPLOYMENT_TEMPLATE = 'DELETE_GAME_DEPLOYMENT_TEMPLATE';

export const DELETE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING = 'DELETE_GAME_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const DELETE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR = 'DELETE_GAME_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const REPLICATE_TEMPLATE = 'REPLICATE_GAME_DEPLOYMENT_TEMPLATE';

export const CLEAN_ERROR = 'CLEAN_ERROR_GAME_DEPLOYMENT_TEMPLATE';

export const SORT = 'SORT_GAME_DEPLOYMENT_TEMPLATE';

export const CANCEL_EDITION = 'CANCEL_EDITION_GAME_DEPLOYMENT_TEMPLATE';

export type GameTemplateReducerState = {
  gameDepTemp: GameTemplateServiceData[];
  gameDepTempId: GameTemplateServiceData | undefined;
} & FetchReducer<'fetch' | 'create' | 'update' | 'delete'> &
  SortState<GameTemplateServiceData>;

type CleanAction = {
  type: 'CLEAN_ERROR_GAME_DEPLOYMENT_TEMPLATE';
  reducerProperty: keyof GameTemplateReducerState;
  errorIndex: number;
  mode?: string;
};

type ResetGameTemplateReducerAction = { type: 'RESET_GAME_TEMPLATE_REDUCER' };

export type GameTemplateActions =
  | FetchAction<'FETCH_GAME_DEPLOYMENT_TEMPLATE', GameTemplateServiceData[]>
  | FetchAction<'FETCH_GAME_DEPLOYMENT_TEMPLATE_ID', GameTemplateServiceData>
  | FetchAction<'CREATE_GAME_DEPLOYMENT_TEMPLATE', GameTemplateServiceData>
  | FetchAction<'UPDATE_GAME_DEPLOYMENT_TEMPLATE', GameTemplateServiceData>
  | FetchAction<'DELETE_GAME_DEPLOYMENT_TEMPLATE', GameTemplateServiceData>
  | { type: 'SORT_GAME_DEPLOYMENT_TEMPLATE'; params: SortParams<GameTemplateServiceData> }
  | { type: 'CANCEL_EDITION_GAME_DEPLOYMENT_TEMPLATE' }
  | ResetGameTemplateReducerAction
  | ResetReducerAction
  | CleanAction;
